import { LocationModel } from '@core/models/location.model';

export interface AddressParts {
  street?: string | null;
  streetNumber?: number | null;
  streetNumberAddition?: string | null;
  postalCode?: string | null;
  city?: string | null;
}

// The street line reads as on the locations tab, and the postcode goes before the city.
export function addressLine(address: AddressParts): string {
  const street = [address.street, address.streetNumber, address.streetNumberAddition]
    .filter(part => part != null && part !== '')
    .join(' ');
  const place = [address.postalCode, address.city].filter(Boolean).join(' ');
  return [street, place].filter(Boolean).join(', ');
}

export function locationAddressLine(location: LocationModel): string {
  return addressLine({
    street: location.locationStreet,
    streetNumber: location.locationStreetNumber,
    streetNumberAddition: location.locationStreetNumberAddition,
    postalCode: location.locationPostalCode,
    city: location.locationCity,
  });
}
